import React from 'react';
import { __ } from 'first-intl';
import { _ } from '@hugendubel/utils';
import { WsBonusShopHistoryTransaction } from '../../../ws/result/WsBonusShopHistory';
import { BonusPointTransaction } from './BonusPointTransaction';

export type BonusPointTransactionTableProps = { transactions: WsBonusShopHistoryTransaction[]; loading: boolean };

export const BonusPointTransactionTable: React.FC<BonusPointTransactionTableProps> = ({ transactions, loading }) => (
    <div className="bonusOrderHistory">
        <table className={_.classNames(loading && 'area-spinner')}>
            <thead>
                <tr>
                    <th className="pointsDirection" />
                    <th className="transaction-time">{__('page.PointHistory.date')}</th>
                    <th className="transaction-type">{__('page.PointHistory.transactionType')}</th>
                    <th className="transaction-revenue">
                        {__(process.env.IS_HUDU ? 'page.PointHistory.revenue' : 'page.PointHistory.validUntil')}
                    </th>
                    <th className="bon-id">
                        {__(
                            process.env.IS_HUDU
                                ? 'page.PointHistory.reference.hudu'
                                : 'page.PointHistory.reference.eBook'
                        )}
                    </th>
                    <th className="points">{__('page.PointHistory.points')}</th>
                </tr>
            </thead>
            <tbody>
                {transactions.map((transaction, index) => (
                    <BonusPointTransaction key={index} transaction={transaction} />
                ))}
            </tbody>
        </table>
    </div>
);
